import { useCallback } from "react";
import { useBaseSummary } from "hooks/useBaseSummary";

export const useInventorySummary = ({ filterValues }) => {
	const buildFilter = useCallback(() => filterValues || {}, [filterValues]);

	return useBaseSummary({
		endpoint: "/inventory-list-summary",
		buildFilter,
		debounceMs: 300,
	});
};
